import { CtSupplierCatalogue } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: true
    },
    tags: {
      field: 'tags',
      label: 'Tags',
      validator: () => true,
      type: 'tag',
      required: false
    },
    production_time: {
      field: 'production_time',
      label: 'Avg. Production Time',
      validator: () => true,
      type: 'number',
      required: false
    },
    shipping_time: {
      field: 'shipping_time',
      label: 'Avg. Shipping Time',
      validator: () => true,
      type: 'number',
      required: false
    },
    supplier: {
      field: 'supplier',
      label: 'Supplier',
      validator: () => true,
      type: 'link',
      required: false
    },
    service: {
      field: 'service',
      label: 'Pingback service configuration',
      validator: () => true,
      type: 'json',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtSupplierCatalogue>(ContentType.SupplierCatalogue, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
